import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const firstError = this.element.querySelector(".has-error, [aria-invalid='true']")
    if (!firstError) return

    firstError.scrollIntoView({ behavior: "smooth", block: "center" })
    const focusable = firstError.querySelector("input, button, select, textarea")
    focusable?.focus({ preventScroll: true })
  }
}
